module.exports = __webpack_public_path__ + "img/level2addon_idle_gun.66a02d52.png";